import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from "moment";
import {WhatsApppricingService} from './whats-apppricing.service'

@Component({
  selector: 'app-whatsapp-pricing',
  templateUrl: './whatsapp-pricing.component.html',
  styleUrls: ['./whatsapp-pricing.component.scss']
})
export class WhatsappPricingComponent implements OnInit {
 applicationDetails:any=[];
 search:any;
 dataSource: any=[];
 pageLoader:boolean = true;
 page:number=1;
 arr:any=[];
 paginationDisabled: boolean=false;
 paginationCount:number=0;
 selectedDateRange: any;
 bsValue = new Date();
 bsValue1 = new Date(moment(Date.now()).subtract(1, 'days').toJSON())  
 bsValueMonth = new Date();
 bsRangeValue: Date[];
 last30DaysToDate: any = moment().format("YYYY-MM-DD");
 last30DaysFromDate: any = moment().subtract(30, "days").format("YYYY-MM-DD");
 toDate: any = moment();
 fromDate: any = moment().subtract(30, "days");
 connectors: any;
 todaysDate: any = moment();
 chooseDate: boolean = false;
 radioStatus: boolean = true;
 recordNotFound:boolean = false;

//  todaysDate: any = moment();
  constructor( private whatsApppricingService: WhatsApppricingService) { }
  displayedColumns: string[] = [
    "companyName",
    "applicationName",
    "wabaId",
    "country",
    "conversationDirection",
    "conversationType",
    "conversationCount",
    "cost"
  ];
  ngOnInit(): void {
    this.selectedDateRange = "last30";
    this.bsRangeValue = [
      new Date(Date.parse(this.fromDate._d)),
      new Date(Date.parse(this.toDate._d)),
    ];
    this.fromDate = moment(this.fromDate).format("YYYY-MM-DD");
    this.toDate = moment(this.toDate).format("YYYY-MM-DD");
    this.getDetails()
  }
  public applyFilter(filterValue: string) { 
    this.arr=[]; 
    this.search = filterValue;
    this.page=1;
    this.arr=[];
    if(filterValue == ""){
      this.arr =  this.applicationDetails;
      this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
      this.recordNotFound=true;
      this.pageLoader= false;
    } else{ 
      var data1: any[];
      data1 = this.applicationDetails.filter(function (ele, i, array) {
        let arrayElementcompany = ele.company.toLowerCase();
        let arrayElementcountrtName = ele.country.toLowerCase();
        let arrayElementWabaId = ele.wabaId.toLowerCase();
        let arrayElementApplicationName = ele.applicationName.toLowerCase();
        return arrayElementcompany.includes(filterValue.toLowerCase()) || arrayElementcountrtName.includes(filterValue.toLowerCase()) || arrayElementWabaId.includes(filterValue.toLowerCase()) || arrayElementApplicationName.includes(filterValue.toLowerCase());
      });
      this.arr = data1;
      this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));       
      this.pageLoader= false;
    }
    this.paginationCount= this.arr.length;  
  }
 
  switchDateRange() {
    this.search="";
    if (this.selectedDateRange === "last30") {
      this.chooseDate = false;
      this.radioStatus = true;
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
        this.getDetails()    
      }
    if (this.selectedDateRange === "choosedate") {
      this.chooseDate = true;
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
    }
  }
  /** SELECT DATES ON CALENDAR **/
  selectDates(events) {
    this.search="";
    if (events) {
      this.fromDate = moment(events[0]).format("YYYY-MM-DD");
      this.toDate = moment(events[1]).format("YYYY-MM-DD");
      this.getDetails()   
     }
  }
  getDetails(){
    this.pageLoader =true;  
    let args = {
      "fromDate": this.fromDate,
       "toDate": this.toDate
    }
    this.applicationDetails=[];
    this.arr=[];
    this.whatsApppricingService.getWhatsAppPricing(args).subscribe((data) => {
      if(data){
        this.applicationDetails=[];
        let dataList = data.info;
    var CompanyData = [];
    Object.keys(dataList).forEach(key =>{
      dataList[key]["wabaId"]= key;
      CompanyData.push(dataList[key])
    })
    CompanyData.map(data =>{
      let obj = {}
      obj["company"]= data.company;
      obj["wabaId"]= data.wabaId;
        var countryDetails =[]
        Object.keys(data.country).forEach(key =>{
          countryDetails.push(data.country[key])
        })
        if(countryDetails.length>0){
        countryDetails.map(data1=>{
            data1.map(elem =>{
              obj["country"]= elem.country;
              obj["applicationName"]= elem.applicationName;
              obj["conversationDirection"]= elem.conversationDirection;
              obj["conversationType"]= elem.conversationType;
              obj["conversationCount"]= elem.conversation;
              elem.messageCost =  Math.round( elem.messageCost * 1e4 ) / 1e4;
              obj["messageCost"]= elem.messageCost;
              this.applicationDetails.push(obj)
              this.applicationDetails = JSON.parse(JSON.stringify(this.applicationDetails))
              })
              this.arr =  this.applicationDetails;
              console.log("this.applicationDetails", this.applicationDetails)
              this.pageLoader= false;
              this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
              if(!this.dataSource) {
                this.pageLoader=false;
               }              
              this.recordNotFound=true;
              this.pageLoader=false;
              setTimeout(()=>{ 
                }, 1000);
                this.pageLoader=false;
                this.paginationCount = this.arr.length;
        })
      }else{
        obj = {};
        this.recordNotFound=true;
        this.dataSource = [];
        // this.applicationDetails=[];
        this.arr=[];
        this.paginationCount = this.arr.length;
        this.pageLoader=false;
}
    })
  }
   else{
   this.dataSource = [];
  //  this.applicationDetails=[];
  //  this.arr=[];
   this.pageLoader=false;
  }
   })
  }
pageChanged2(page){
    this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 10, (this.page - 1) * 10 + 10));
   }

}
